import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative h-[350px] md:h-[420px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20anime%20style%20illustration%20of%20a%20magical%20floating%20island%20with%20cute%20chibi%20characters%20gathered%20around%20a%20glowing%20crystal%2C%20pastel%20pink%20and%20mint%20green%20background%2C%20soft%20ethereal%20lighting%2C%20sparkling%20particles%2C%20dreamy%20atmosphere%2C%20warm%20and%20inviting%20scene%2C%20high%20quality%20illustration&width=900&height=600&seq=about-preview-island&orientation=landscape"
              alt="重生萝莉岛品牌介绍"
              title="重生萝莉岛品牌"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-6">
              关于重生萝莉岛
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              重生萝莉岛是一个以神秘岛屿为背景的重生冒险题材内容平台。我们汇聚了最全面的攻略指南、最深度的剧情解析、最详尽的角色图鉴，以及最精彩的冒险故事。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-6">
              无论你是初入岛的新手冒险者，还是追求极致的老玩家，重生萝莉岛都是你最好的冒险伙伴。加入我们，一起探索这座神秘岛屿的无限可能！
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/about"
                className="px-6 py-2.5 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
              <Link
                to="/category/gonglue"
                className="px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览攻略
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}